<template>
  <v-app>
    <v-main>
      <div class="my-10 bg-secondary ma-auto pa-2">
        <div
          class="text-md-center my-5"
          style="font-family: heisei-mincho-std, serif;font-size: x-large;"
        >
          エルミナージュORIGINAL~闇の巫女と神々の指輪~<br />不具合報告フォーム
        </div>
        <!-- <v-img
          :width="800"
          aspect-ratio="16/9"
          cover
          src="http://d-mebius.com/elminages/img/ss_st.jpg"
          class="ma-auto"
        ></v-img> -->
 <p class="text-body1 pa-1 text-left text-md-center"
  style="line-height: 1.5em; max-width: 960px; margin: 0 auto;"
          >
		こちらはNintendo Switch「エルミナージュORIGINAL~闇の巫女と神々の指輪~」 製品版の不具合報告フォームです。
		<br/>
		※要望や感想を送っていただくフォームではございません。<br/>
		頂きました内容を全て反映できないこともございます。<br/>
		また頂きました内容に関し、基本的に返信することはございませんので、ご了承願います。
  </p>
 <BugForm />
        <div
          class="text-center my-2"
          style="font-family: heisei-mincho-std, serif;font-size: large;"
        >- 個人情報保護方針 -</div>
        <p style="text-align:left; line-height: 1.5em; max-width: 960px; margin: 0 auto;"
          class="text-body1 pa-1">当社はお客様より取得しました個人情報を、ご本人の同意なくあらかじめ明示した利用目的以外に利用する事はございません。<br>
	当社はお客様の個人情報を、特段の事情がない限り、お客様の承諾なく第三者に開示、提供する事は致しません。<br>
	お客様ご自身の個人情報について照会、修正、削除の要請を受けた場合には、合理的な範囲で速やかに対応致します。<br>
	このプライバシーポリシーの内容は、定期的に見直しを行い、継続的な改善を行います。</p>
      </div>

      <AppFooter />
     
    </v-main>
  </v-app>
</template>


 <script>
  import AppFooter from "./AppFooter.vue";
  import BugForm from "./BugForm.vue";
  export default {
    components: {
      BugForm,
      AppFooter,
    },
  };
</script>

<style scoped>
  .d_area {
    border: #fff solid 1px;
    padding: 2em;
    margin: 2em auto !important;
    line-height: 2.5em;
     max-width: 1280px;
  }
  .d_area p {
    margin: 1em auto;
  }
</style>
